import React from 'react'
import { useMessageSupport } from '../../Hook/App'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'

function Index() {
    const { onChange, send, loading } = useMessageSupport();
    return (
        <Layout>
            <HeaderMain lable="ارسال پیام" />
            <div className="message-support  pt-3">
                <div className="input-meain">
                    <span className='mb-3 d-block'>موضوع خودرا مشخص کنید</span>
                    <input onChange={onChange} name="title" className="input" />
                </div>
                <div className="input-meain">
                    <span className='mb-3 d-block'>پیام</span>
                    <textarea onChange={onChange} name="message" className="input" rows="3"></textarea>
                </div>
                <div className="section-end">
                    <button onClick={send} disabled={loading.send}>{loading.send ? <span className="spinner-border spinner-border-sm"></span> : "ارسال پیام"}</button>
                </div>
            </div>
        </Layout>
    )
}

export default Index